import { Instance, SnapshotIn, types } from 'mobx-state-tree';

export interface MobileProps {
  androidScheme?: string;
  androidPackage?: string;
  iOsBundleIdentifier?: string;
}

export const Mobile = types.model({
  androidScheme: types.maybe(types.string),
  androidPackage: types.maybe(types.string),
  iOsBundleIdentifier: types.maybe(types.string),
});

export type MobileSnapshot = SnapshotIn<typeof Mobile>;
export type MobileInstance = Instance<typeof Mobile>;
